
import Vue from 'vue'
import { AxiosError } from 'axios'
import {
  fetchChangelogEntries,
  formatChangelogDateTime,
  resolveChangelogAxiosErrorMessage,
} from '@/utils/changelog'

interface ChangelogRow {
  id: number
  date: string
  updated_at: string
  status: 'draft' | 'published' | 'archived'
  title: string
  description: string
}

interface ChangelogFilters {
  title: string
  status: string | null
  date: string
}

export default Vue.extend({
  name: 'AdminChangelog',
  data() {
    return {
      loading: false,
      error: null as string | null,
      items: [] as ChangelogRow[],
      filters: {
        title: '',
        status: null,
        date: '',
      } as ChangelogFilters,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: String(this.$vuetify.lang.t('$vuetify.admin.changelog.col_title')), value: 'title' },
        { text: String(this.$vuetify.lang.t('$vuetify.admin.changelog.col_date')), value: 'date' },
        { text: String(this.$vuetify.lang.t('$vuetify.admin.changelog.col_status')), value: 'status' },
        { text: String(this.$vuetify.lang.t('$vuetify.description')), value: 'description', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ]
    },
    statusItems() {
      return [
        { value: 'draft', label: String(this.$vuetify.lang.t('$vuetify.admin.changelog.status_draft')) },
        { value: 'published', label: String(this.$vuetify.lang.t('$vuetify.admin.changelog.status_published')) },
        { value: 'archived', label: String(this.$vuetify.lang.t('$vuetify.admin.changelog.status_archived')) },
      ]
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      this.error = null
      const params: Record<string, string> = {}
      if (this.filters.title.trim()) params.title = this.filters.title.trim()
      if (this.filters.status) params.status = this.filters.status
      if (this.filters.date) params.date = this.filters.date

      const { items, error } = await fetchChangelogEntries<ChangelogRow>(
        '/v1/admin/changelog',
        params,
        { resolveError: err => this.resolveAxiosErrorMessage(err) },
      )
      this.items = items
      this.error = error
      this.loading = false
    },
    formatDate(value: string): string {
      return formatChangelogDateTime(value, String(this.$vuetify.lang.current))
    },
    statusLabel(status: ChangelogRow['status']): string {
      const key = `$vuetify.admin.changelog.status_${status}`
      return String(this.$vuetify.lang.t(key))
    },
    statusColor(status: ChangelogRow['status']): string {
      if (status === 'published') return 'success'
      if (status === 'archived') return 'grey'
      return 'orange'
    },
    resolveAxiosErrorMessage(err: AxiosError): string {
      return resolveChangelogAxiosErrorMessage(err, key => this.$vuetify.lang.t(key))
    },
  },
})
